import { Component, Input } from 'ng-metadata/core';

import './reach.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentReach
 * @module mw.components.contentDocuments
 * @param {number} [reach] - The reach of the document
 * @param {string} [source-url] - The url of the source
 * @description
 * `mw-content-document-reach` is a component that shows a document's reach in the properly formatted way
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-reach reach="500000"> </mw-content-document-reach>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-reach',
    template: `
        <div class="mw-content-document-reach">
            <div>
                <ul class="mw-content-document-reach__list">
                    <li class="mw-content-document-reach__list-item">
                        <span>Reach:</span>
                    </li>
                    <li class="mw-content-document-reach__list-item">
                        <span class="mw-content-document-reach__count">
                            <a href="https://www.similarweb.com/website/{{::$ctrl.sourceUrl}}" target="_blank">
                                <span translate>{{::$ctrl.desktop | mwTruncateNumber }} desktop </span>
                            </a>
                    </li>
                    <li class="mw-content-document-reach__list-item">
                        <span class="mw-content-document-reach__count">
                            <a href="https://www.similarweb.com/website/{{::$ctrl.sourceUrl}}" target="_blank">
                                <span translate>{{::$ctrl.mobile | mwTruncateNumber }} mobile </span>
                            </a>
                    </li>
                </ul>
            </div>
        </div>
    `
})

export class ReachComponent {
    @Input('<') reach: number;
    @Input('<') sourceUrl: string;
    @Input('<') desktop: number = 0;
    @Input('<') mobile: number = 0;

    constructor () {
        if(this.desktop === 0 && this.mobile === 0) {
            this.desktop = this.reach;
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/reach/reach.component.ts